import React from "react";

const services = [
  {
    title: "DevOps & Cloud Engineering",
    icon_head: "../assets/icons/about-us/cluod.png",
    description:
      "Modernize your infrastructure with automated pipelines, secure cloud environments, and always-on scalability.",
  },
  {
    title: "AI Automation",
    icon_head: "../assets/icons/about-us/ai-auto.png",
    description:
      "Deploy intelligent voice, chat, and autonomous agents that elevate customer experiences and operational efficiency.",
  },
  {
    title: "VoIP & Communication Platforms",
    icon_head: "../assets/icons/about-us/communication.png",
    description:
      "Design carrier-grade VoIP, WebRTC, and contact center solutions tailored to telecom-grade reliability.",
  },
  {
    title: "Custom Software & Product Engineering",
    icon_head: "../assets/icons/about-us/product-eng.png",
    description:
      "Build web, mobile, and platform products that align to your business roadmap with rapid delivery cycles.",
  },
  {
    title: "Managed Services & Support",
    icon_head: "../assets/icons/about-us/customer-support.png",
    description:
      "Rely on proactive monitoring, optimization, and 24x7 support for mission-critical workloads.",
  },
  {
    title: "Consulting & Strategy",
    icon_head: "../assets/icons/about-us/strategy.png",
    description:
      "Engage with seasoned solution architects to define technology blueprints and transformation journeys.",
  },
];

const values = [
  {
    title: "Customer Obsession",
    icon_head: "../assets/icons/about-us/Customer-Obsession.png",
    description:
      "Every solution starts with understanding business goals, KPIs, and the experience you want to deliver.",
  },
  {
    title: "Innovation First",
    icon_head: "../assets/icons/about-us/innovation.png",
    description:
      "We stay ahead of emerging tech—AI agents, service mesh, serverless—to keep you a step ahead.",
  },
  {
    title: "Security by Design",
    icon_head: "../assets/icons/about-us/security.png",
    description:
      "Secure architectures, compliance readiness, and continuous testing are embedded in our delivery playbook.",
  },
  {
    title: "Transparent Delivery",
    icon_head: "../assets/icons/about-us/delivery.png",
    description:
      "Agile pods, measurable milestones, and clear communication ensure zero surprises.",
  },
];

const reasons = [
  {
    title: "13+ years of multi-vertical delivery experience",
    icon_head: "../assets/icons/about-us/experience.png",
  },
  {
    title: "Certified experts across AWS, Azure, Google Cloud, and Kubernetes",
    icon_head: "../assets/icons/about-us/certified.png",
  },
  {
    title: "Battle-tested accelerators for CI/CD, observability, and automation",
    icon_head: "../assets/icons/about-us/battel.png",
  },
  {
    title: "Flexible engagement: product squads, dedicated engineers, or co-build pods",
    icon_head: "../assets/icons/about-us/flex.png",
  },

];

const technologies = [
  "AWS",
  "Azure",
  "Google Cloud",
  "Kubernetes",
  "Docker",
  "Terraform",
  "Helm",
  "ArgoCD",
  "Jenkins",
  "GitHub Actions",
  "Node.js",
  "React",
  "Python",
  "GoLang",
  "PostgreSQL",
  "MongoDB",
];

const teamMembers = [
  {
     name: "Ananya Sharma", 
     role: "Head of Delivery" ,
     team_images:"../assets/images/about-us/team-1.jpg"
    },
  {
     name: "Rohit Mehta", 
     role: "Lead Solution Architect",
     team_images:"../assets/images/about-us/team-3.png"
  },
  { 
    name: "Priya Bhatt",
    role: "AI & Voice Practice Lead",
    team_images:"../assets/images/about-us/team-2.jpg"
  },
  {
    name: "Karan Verma",
    role: "Principal DevOps Engineer",
    team_images:"../assets/images/about-us/team-4.jpg"
  },
];

const AboutUs = () => {
  return (
    <div className="pt-32 pb-20">
      {/* Hero */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <div>
            <p className="uppercase text-blue-600 font-semibold tracking-wide mb-3">
              About Ayanshtech Solutions
            </p>
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 leading-tight mb-6">
              Building Future-Ready Platforms, Products, and Experiences
            </h1>
            <p className="text-lg text-gray-700 mb-4">
              <a
    className="relative 
    before:content-[''] before:absolute before:left-1/2 before:-bottom-1 
    before:h-[2px] before:w-0 before:bg-green-600 
    before:transition-all before:duration-300 
    hover:before:left-0 hover:before:w-full text-green-600 font-bold"
    href="https://ayanshtechnology.com/"
  >
   Ayanshtech Solutions
  </a> is a product engineering and digital
              innovation partner helping ambitious teams ship cloud-native,
              AI-powered, and carrier-grade experiences. We combine strategic
              consulting with deep implementation skills to move ideas from
              whiteboard to scale.
            </p>
            <p className="text-lg text-gray-700">
              From <a
    className="relative 
    before:content-[''] before:absolute before:left-1/2 before:-bottom-1 
    before:h-[2px] before:w-0 before:bg-green-600 
    before:transition-all before:duration-300 
    hover:before:left-0 hover:before:w-full text-green-600 font-bold"
    href="https://ayanshtechnology.com/sms-broadcasting-system"
  >
   VoIP innovation
  </a> to <a
    className="relative 
    before:content-[''] before:absolute before:left-1/2 before:-bottom-1 
    before:h-[2px] before:w-0 before:bg-green-600 
    before:transition-all before:duration-300 
    hover:before:left-0 hover:before:w-full text-green-600 font-bold"
    href="https://ayanshtechnology.com/devops-aws"
  >
    DevOps automation
  </a> and <a
    className="relative 
    before:content-[''] before:absolute before:left-1/2 before:-bottom-1 
    before:h-[2px] before:w-0 before:bg-green-600 
    before:transition-all before:duration-300 
    hover:before:left-0 hover:before:w-full text-green-600 font-bold"
    href="https://ayanshtechnology.com/ai-agent"
  >  Autonomous AI Agent </a>, we enable
              enterprises and scale-ups to launch faster, operate securely, and
              compete globally.
            </p>
          </div>
          <div className="flex justify-center">
            <img
              src="../assets/images/about-us/banner.png"
              alt="Ayanshtech team working together"
              className="w-full "
            />
          </div>
        </div>
      </section>

      {/* Our Story */}
      <section className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 mt-20">
        <div className="bg-blue-50 rounded-3xl p-8 lg:p-12 shadow-lg">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">
                Our Story
              </h2>
              <p className="text-gray-700">
                Founded by telecom and cloud engineers, Ayanshtech has grown
                into a multi-disciplinary technology studio trusted by customers
                across the globe.
              </p>
            </div>
            <div>
              <div className="flex item-center gap-2 mb-2">
                <img src="../assets/icons/about-us/mission.png" className="w-[30px]" alt="" />
                <h3 className="text-xl item-center font-semibold text-blue-700">
                  Mission
                </h3>
              </div>
              <p className="text-gray-700">
                Empower businesses with resilient, data-driven platforms that
                accelerate time-to-market while delivering measurable business
                outcomes.
              </p>
              <div className="flex item-center gap-2 mb-2 mt-4">
                <img src="../assets/icons/about-us/vission.png" className="w-[30px]" alt="" />
                <h3 className="text-xl font-semibold text-blue-700 ">
                  Vision
                </h3>
              </div>
              <p className="text-gray-700">
                To be the engineering nerve center for enterprises reinventing
                telecom, communication, and digital operations with cloud and
                AI.
              </p>
            </div>
            <div>
              <div className="flex item-center gap-2 mb-2">
                <img src="../assets/icons/about-us/Journey.png" className="w-[30px]" alt="" />
                <h3 className="text-xl font-semibold text-blue-700">
                  Journey
                </h3>
              </div>
              <p className="text-gray-700">
                Our path spans custom telephony products, large-scale contact
                center deployments, cloud modernization, and AI-led automation.
                Each milestone sharpened our playbooks for designing secure,
                compliant, and scalable ecosystems.
              </p>
              <p className="text-gray-700 mt-4">
                Today, we engage as long-term partners—owning product strategy,
                delivering managed DevOps and SRE, and powering intelligent
                customer experiences.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* What We Do */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-20">
        <div className="text-center mb-10">
          <p className="uppercase text-blue-600 font-semibold tracking-wide">
            What We Do
          </p>
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mt-3">
            Outcome-Focused Engineering Offerings
          </h2>
          <p className="text-lg text-gray-600 mt-4 max-w-3xl mx-auto">
            We blend consulting, design, and delivery into cohesive pods that
            help enterprise and high-growth teams launch secure, scalable, and
            delightful digital experiences.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service) => (
            <div
              key={service}
              className="
        rounded-3xl shadow-md p-6 border border-gray-100
        transition-all duration-300 ease-out transform-gpu
        hover:scale-105 hover:shadow-1xl
        hover:bg-gradient-to-l hover:from-blue-300 hover:to-green-200 hover:border-none
      "
            >
              <div className="flex gap-2 mb-2">
                <img src={service.icon_head} className="w-[50px]" alt="icon" />
                <h3 className="text-xl font-semibold text-gray-900 self-center">
                  {service.title}
                </h3>
              </div>
              <p className="text-gray-700">{service.description}</p>
            </div>
          ))}
        </div>

      </section>

      {/* Core Values */}
      <section className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 mt-20">
        <div className="text-center mb-10">
          <p className="uppercase text-blue-600 font-semibold tracking-wide">
            Core Values
          </p>
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mt-3">
            How We Partner and Deliver
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {values.map((value) => (
            <div
              key={value}
              className="
        rounded-3xl shadow-md p-6 border border-gray-100
        transition-all duration-300 ease-out transform-gpu
        hover:scale-105 hover:shadow-1xl
        hover:bg-gradient-to-l hover:from-blue-300 hover:to-green-200 hover:border-none
      "
            >
              <div className="flex gap-2 mb-2">
                <img src={value.icon_head} className="w-[50px]" alt="icon" />
                <h3 className="text-2xl font-semibold text-gray-900 self-center">
                  {value.title}
                </h3>
              </div>
              <p className="text-gray-700">{value.description}</p>
            </div>
          ))}
        </div>

      </section>

      {/* Why Choose Us */}
      <section className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 mt-20">
        <div className="text-center mb-10">
          <p className="uppercase text-blue-600 font-semibold tracking-wide">
            Why Choose Us
          </p>
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mt-3">
            A Partner Invested in Your Success
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {reasons.map((reason) => (
            <div
              key={reason}
              className="
        flex items-start gap-3
        rounded-3xl shadow-md p-6 border border-gray-100
        transition-all duration-300 ease-out transform-gpu
        hover:scale-105 hover:shadow-1xl
        hover:bg-gradient-to-l hover:from-blue-300 hover:to-green-200 hover:border-none
      "
            >
              <img src={reason.icon_head} className="w-[50px]" alt="" />
              <p className="text-gray-700 text-lg">{reason.title}</p>
            </div>
          ))}
        </div>

      </section>

      {/* Global Presence */}
      <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 mt-20">
        <div className="text-center mb-8">
          <p className="uppercase text-blue-600 font-semibold tracking-wide">
            Global Presence
          </p>
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mt-3">
            Local Access, Global Delivery
          </h2>
          <p className="text-lg text-gray-600 mt-4">
            Two strategic delivery hubs ensure responsive collaboration and
            around-the-clock project velocity.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="group rounded-3xl shadow-md p-6 border border-gray-100  border border-gray-100
        transition-all duration-300 ease-out transform-gpu
        hover:scale-105 hover:shadow-1xl
        hover:bg-gradient-to-l hover:from-blue-500 hover:to-green-500 hover:border-none  hover:cursor-pointer">
            <h3 className="text-2xl font-semibold text-gray-900 group-hover:text-white mb-2">
              India (HQ)
            </h3>
            <p className="text-gray-700 group-hover:text-white">
              VoIP, AI automation, DevOps, WebRTC, cloud, CI/CD, Kubernetes, chatbots, analytics, and call center solutions with innovation labs and 24×7 managed services.
            </p>
            <p className="text-blue-700 font-semibold mt-4 group-hover:text-white">
              +91-8802319226 · info@ayanshtechnology.com
            </p>
          </div>
          <div className="group rounded-3xl shadow-md p-6 border border-gray-100  border border-gray-100
        transition-all duration-300 ease-out transform-gpu
        hover:scale-105 hover:shadow-1xl
        hover:bg-gradient-to-l hover:from-blue-500 hover:to-green-500 hover:border-none hover:cursor-pointer">
            <h3 className="text-2xl font-semibold text-gray-900 group-hover:text-white mb-2">
              USA Office
            </h3>
            <p className="text-gray-700 group-hover:text-white">
              Customer success teams and solution architects supporting North
              America and Europe.
            </p>
            <p className="text-blue-700 group-hover:text-white font-semibold mt-4">
              +1-917-283-4232 · business@ayanshtechnology.com
            </p>
          </div>
        </div>
      </section>

      {/* Technologies We Use */}
      <section className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 mt-20">
        <div className="text-center mb-8">
          <p className="uppercase text-blue-600 font-semibold tracking-wide">
            Technologies We Use
          </p>
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mt-3">
            Future-Proof Stacks and Toolchains
          </h2>
        </div>
        <div className="flex flex-wrap justify-center gap-4">
          {technologies.map((tech) => (
            <span
              key={tech}
              className="
        group
        relative z-0
        px-4 py-2 rounded-full font-semibold
        bg-red-50 text-blue-700 border border-blue-100
        overflow-hidden cursor-pointer transition-all
        
        before:absolute before:inset-0
        before:bg-gradient-to-r before:from-blue-500 before:to-green-500
        before:translate-x-[-101%]
        before:transition-transform before:duration-300
        hover:before:translate-x-0
      "
            >
              <span className="relative z-10 group-hover:text-white">
                {tech}
              </span>
            </span>
          ))}
        </div>


      </section>

      {/* Team */}
      <section className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 mt-20">
        <div className="text-center mb-10">
          <p className="uppercase text-blue-600 font-semibold tracking-wide">
            Our Team
          </p>
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mt-3">
            Specialists Driving Every Engagement
          </h2>
          <p className="text-lg text-gray-600 mt-4">
            Meet a few of the leaders steering Ayanshtech squads. Full team
            details available on request.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
          {teamMembers.map((member) => (
            <div
              key={member.name}
              className=" rounded-3xl shadow-lg p-6 text-center border border-gray-100"
            >
              {/* <div className="w-20 h-20 mx-auto mb-4 rounded-full bg-blue-100 flex items-center justify-center text-2xl font-bold text-blue-700">
                {member.name
                  .split(" ")
                  .map((n) => n[0])
                  .join("")}
              </div> */}
              <div className=" flex item-center rounded-full justify-center">
                <img src={member.team_images} alt="teams" className="w-[80px]  h-[80px]  rounded-full self-center" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900">
                {member.name}
              </h3>
              <p className="text-gray-600 mt-2">{member.role}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Final CTA */}
      <section className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 mt-20 pb-10">
        <div className="bg-gradient-to-r from-blue-600 to-green-500 rounded-3xl p-10 text-center shadow-2xl text-white">
          <h2 className="text-3xl sm:text-4xl font-bold mb-4">
            Ready to build with Ayanshtech Solutions?
          </h2>
          <p className="text-lg sm:text-xl mb-6">
            Partner with our strategists, architects, and delivery squads to
            launch your next platform or automate mission-critical workflows.
          </p>
          <a
            href="/contactUs"
            className="inline-flex bg-white items-center justify-center px-8 py-3  text-blue-700 font-semibold rounded-full shadow-lg hover:bg-blue-50"
          >
            Contact Us
          </a>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;

